import { appLoading } from "../actions/alertAction";
import {
  CUSTOMER_INFO_RECEIVED,
  CUSTOMER_PAYMENT_METHODS_RECEIVED,
  CUSTOMER_INFO_BY_ID_RECEIVED,
} from "../constants/types/acumaticaType";
import { ERROR, SUCCESS } from "../constants/types/alertType";
import axios from "../utils/axios";
export const acumaticaPostAction = (data, callback) => (dispatch) => {
  axios.post("acumatica", data).then(
    (resp) => {
      if (resp?.data?.result === "success") {
        dispatch({
          type: SUCCESS,
          payload: resp?.data?.message,
        });
        callback && callback();
      } else {
        callback && callback();
        dispatch({
          type: ERROR,
          payload: resp?.data?.error,
        });
      }
    },
    (err) => {
      callback && callback();
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const acumaticaGetCustomer = (data, callback) => (dispatch) => {
  axios.get(`acumatica?action=getEbizchargeCustomer`).then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: CUSTOMER_INFO_RECEIVED,
          payload: resp.data.customer,
        });
      } else {
        dispatch({
          type: CUSTOMER_INFO_RECEIVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp?.data?.error,
        });
      }

      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get address list",
      });
    }
  );
};

export const acumaticaGetCustomerPaymentMethods =
  (customerId, callback) => (dispatch) => {
    axios
      .get(
        `acumatica?action=getEbizchargeCustomerPaymentMethodProfiles&customerId=${customerId}`
      )
      .then(
        (resp) => {
          if (resp.data?.result == "success") {
            dispatch({
              type: CUSTOMER_PAYMENT_METHODS_RECEIVED,
              payload: resp.data.paymentMethods,
            });
          } else {
            dispatch({
              type: CUSTOMER_PAYMENT_METHODS_RECEIVED,
              payload: [],
            });
            dispatch({
              type: ERROR,
              payload: resp?.data?.error,
            });
          }

          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to get payment methods",
          });
        }
      );
  };

export const getCustomerById = (customerId, callback) => (dispatch) => {
  axios.get(`acumatica?action=getCustomerById&customerId=${customerId}`).then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: CUSTOMER_INFO_BY_ID_RECEIVED,
          payload: resp.data,
        });
      } else {
        dispatch({
          type: CUSTOMER_INFO_BY_ID_RECEIVED,
          payload: null,
        });
        dispatch({
          type: ERROR,
          payload: resp?.data?.error,
        });
      }

      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to address Info",
      });
    }
  );
};
